/**
 * Module which provides a default, unauthenticated user state.
 */

const createDefaultUser = () => ({
  username: '',
  email: '',
  hashed_email: '',
  first_name: '',
  last_name: '',
  auth_token: null,
  userId: null,
  terms_accepted: false,
  referral: null,
  phone_number: '',
  is_superuser: false,
  is_staff: false,
  is_anon: true,
  mfa_required: false,
  messaging_status: null,
  facebook_id: null,
  has_usable_password: false,
  errors: null,
  ss_tracking_cookie: null,
  jwt_token: null,
  is_new_user: false,
});

export default createDefaultUser;
